<template>
  <section class="w-full min-h-screen bg-[#f3f7f9] px-3 pt-16 pb-5 sm:px-6 sm:pt-20 sm:pb-8 text-plomo">
    <form @submit.prevent="submitClient" class="max-w-3xl mx-auto space-y-6">
      <button
        type="button"
        class="w-full rounded-2xl px-4 py-3 text-center text-sm font-bold uppercase tracking-wide transition"
        :class="form.disponibleAhora ? 'bg-gold text-plomo shadow-lg' : 'border border-slate-300 bg-white text-slate-400'"
        @click="form.disponibleAhora = !form.disponibleAhora"
      >
        Disponible justo ahora
      </button>

      <div class="relative" ref="tipoDropdownRef">
        <button
          type="button"
          @click="showTipoOptions = !showTipoOptions"
          class="flex w-full items-center justify-between rounded-2xl border border-slate-300 bg-white px-4 py-3 text-left text-plomo transition focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40"
          :class="[
            errors.tipoLocal ? 'border-gold focus:border-gold focus:ring-gold/40' : '',
            showTipoOptions ? 'border-gold ring-2 ring-gold/40' : ''
          ]"
        >
          <span :class="form.tipoLocal ? 'text-plomo' : 'text-slate-400'">
            {{ form.tipoLocal || 'Seleccionar categoría' }}
          </span>
          <ChevronDownIcon
            class="h-5 w-5 shrink-0 text-slate-400 transition-transform duration-200"
            :class="{ 'rotate-180 text-carmesi': showTipoOptions }"
          />
        </button>

        <Transition name="dropdown-fade">
          <ul
            v-if="showTipoOptions"
            class="absolute z-30 mt-2 w-full overflow-y-auto rounded-2xl border border-slate-200 bg-white p-1.5 shadow-2xl shadow-black/10"
          >
            <li v-for="tipo in tipoLocalOptions" :key="tipo">
              <button
                type="button"
                @click="setTipoLocal(tipo)"
                class="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm transition hover:bg-carmesi/10"
                :class="form.tipoLocal === tipo ? 'bg-carmesi/10 font-semibold text-carmesi' : 'text-plomo'"
              >
                <span class="lowercase">{{ tipo === 'Independiente' ? 'INDEPENDIENTE' : 'NIGHT CLUB' }}</span>
                <CheckIcon v-if="form.tipoLocal === tipo" class="h-4 w-4 shrink-0 text-carmesi" />
              </button>
            </li>
          </ul>
        </Transition>

        <ErrorTooltip :message="errors.tipoLocal" />
      </div>

      <div v-if="showNombreStep" class="grid grid-cols-1 gap-4" :class="{ 'md:grid-cols-2': form.tipoLocal !== 'Night Club' }">
        <div class="relative">
          <input
            v-model="form.nombre"
            type="text"
            placeholder=" "
            id="rc-nombre"
            @input="validateNombre"
            @blur="validateNombre"
            class="peer w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-slate-800 focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40"
            :class="{ 'border-gold focus:border-gold focus:ring-gold/40': errors.nombre }"
            required
          />
          <label
            for="rc-nombre"
            class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-slate-400 transition-all duration-150 peer-focus:-top-2.5 peer-focus:left-3 peer-focus:translate-y-0 peer-focus:rounded peer-focus:bg-[#f3f7f9] peer-focus:px-1 peer-focus:text-[11px] peer-focus:text-slate-500 peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:rounded peer-not-placeholder-shown:bg-[#f3f7f9] peer-not-placeholder-shown:px-1 peer-not-placeholder-shown:text-[11px] peer-not-placeholder-shown:text-slate-500"
          >
            Nombre
          </label>
          <ErrorTooltip :message="errors.nombre" />
        </div>

        <div class="relative" v-if="form.tipoLocal !== 'Night Club' && showEdadStep">
          <input
            v-model.number="form.edad"
            type="number"
            min="0"
            placeholder=" "
            id="rc-edad"
            @input="validateEdad"
            @blur="validateEdad"
            class="peer w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-slate-800 focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40"
            :class="{ 'border-gold focus:border-gold focus:ring-gold/40': errors.edad }"
          />
          <label
            for="rc-edad"
            class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-slate-400 transition-all duration-150 peer-focus:-top-2.5 peer-focus:left-3 peer-focus:translate-y-0 peer-focus:rounded peer-focus:bg-[#f3f7f9] peer-focus:px-1 peer-focus:text-[11px] peer-focus:text-slate-500 peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:rounded peer-not-placeholder-shown:bg-[#f3f7f9] peer-not-placeholder-shown:px-1 peer-not-placeholder-shown:text-[11px] peer-not-placeholder-shown:text-slate-500"
          >
            Edad
          </label>
          <ErrorTooltip :message="errors.edad" />
        </div>
      </div>

      <div v-if="showContactoStep" class="relative">
        <input
          v-model="form.telefonoVisible"
          type="tel"
          placeholder=" "
          id="rc-contacto"
          @blur="validateTelefono"
          class="peer w-full rounded-2xl border border-slate-300 bg-white pl-12 pr-4 py-3 text-slate-800 focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40"
          :class="{ 'border-gold focus:border-gold focus:ring-gold/40': errors.telefono }"
          @input="
            form.telefonoVisible = form.telefonoVisible.replace(/[^0-9]/g, '');
            form.telefono = '591' + form.telefonoVisible;
            validateTelefono();
          "
        />
        <label
          for="rc-contacto"
          class="pointer-events-none absolute left-12 top-1/2 -translate-y-1/2 text-base text-slate-400 transition-all duration-150 peer-focus:-top-2.5 peer-focus:left-3 peer-focus:translate-y-0 peer-focus:rounded peer-focus:bg-[#f3f7f9] peer-focus:px-1 peer-focus:text-[11px] peer-focus:text-slate-500 peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:rounded peer-not-placeholder-shown:bg-[#f3f7f9] peer-not-placeholder-shown:px-1 peer-not-placeholder-shown:text-[11px] peer-not-placeholder-shown:text-slate-500"
        >
          Contacto
        </label>
        <svg viewBox="0 0 32 32" class="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 shrink-0 pointer-events-none" fill="#25D366" aria-hidden="true">
          <path d="M16.004 3C9.375 3 3.997 8.373 3.997 15c0 2.24.62 4.42 1.797 6.318L3 29l7.86-2.744A12.93 12.93 0 0 0 16.004 27C22.632 27 28 21.628 28 15S22.632 3 16.004 3Zm0 23.36a10.31 10.31 0 0 1-5.26-1.44l-.377-.224-4.667 1.63 1.55-4.55-.246-.394a10.35 10.35 0 0 1-1.6-5.382c0-5.717 4.652-10.37 10.6-10.37 5.947 0 10.6 4.652 10.6 10.37 0 5.717-4.653 10.36-10.6 10.36Zm5.82-7.77c-.32-.16-1.89-.933-2.183-1.04-.293-.107-.507-.16-.72.16-.213.32-.827 1.04-1.014 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.497-2.573-1.587-.951-.848-1.593-1.895-1.78-2.215-.187-.32-.02-.493.14-.653.144-.144.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.733-.987-2.373-.26-.626-.524-.54-.72-.55-.187-.008-.4-.01-.613-.01-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.253 3.44 5.46 4.826.763.33 1.36.527 1.825.674.767.244 1.466.21 2.018.127.616-.092 1.89-.773 2.157-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373Z"/>
        </svg>
        <ErrorTooltip :message="errors.telefono" />
      </div>

      <div v-if="showNacionalidadCiudadStep" class="grid grid-cols-1 gap-4" :class="{ 'md:grid-cols-2': form.tipoLocal !== 'Night Club' }">
        <!-- Nacionalidad -->
        <div class="relative" ref="nacionalidadDropdownRef" v-if="form.tipoLocal !== 'Night Club'">
          <button
            type="button"
            @click="showNacionalidadDropdown = !showNacionalidadDropdown"
            class="flex w-full items-center justify-between rounded-2xl border border-slate-300 bg-white px-4 py-3 text-left text-plomo transition focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40"
            :class="[
              errors.nacionalidad ? 'border-gold focus:border-gold focus:ring-gold/40' : '',
              showNacionalidadDropdown ? 'border-gold ring-2 ring-gold/40' : ''
            ]"
          >
            <span class="flex items-center gap-2" :class="form.nacionalidad ? 'text-plomo' : 'text-slate-400'">
              <img
                v-if="form.nacionalidad"
                :src="getFlag(form.nacionalidad)"
                alt="Bandera"
                class="w-7 h-5 rounded-sm object-cover border border-slate-300"
              />
              {{ form.nacionalidad || 'Seleccionar nacionalidad' }}
            </span>
            <ChevronDownIcon
              class="h-5 w-5 shrink-0 text-slate-400 transition-transform duration-200"
              :class="{ 'rotate-180 text-carmesi': showNacionalidadDropdown }"
            />
          </button>

          <Transition name="dropdown-fade">
            <ul
              v-if="showNacionalidadDropdown"
              class="absolute z-30 mt-2 max-h-64 w-full overflow-y-auto rounded-2xl border border-slate-200 bg-white p-1.5 shadow-2xl shadow-black/10"
            >
              <li v-for="nacionalidad in nacionalidadOptions" :key="nacionalidad">
                <button
                  type="button"
                  @click="selectNacionalidad(nacionalidad)"
                  class="flex w-full items-center gap-2 rounded-xl px-3 py-2.5 text-left text-sm transition hover:bg-carmesi/10"
                  :class="form.nacionalidad === nacionalidad ? 'bg-carmesi/10 font-semibold text-carmesi' : 'text-plomo'"
                >
                  <img
                    :src="getFlag(nacionalidad)"
                    alt="Bandera"
                    class="w-6 h-4 shrink-0 rounded-sm object-cover border border-slate-300"
                  />
                  <span class="flex-1">{{ nacionalidad }}</span>
                  <CheckIcon v-if="form.nacionalidad === nacionalidad" class="h-4 w-4 shrink-0 text-carmesi" />
                </button>
              </li>
            </ul>
          </Transition>

          <ErrorTooltip :message="errors.nacionalidad" />
        </div>

        <!-- Ciudad -->
        <div class="relative" ref="ciudadDropdownRef" v-if="showCiudadField">
          <button
            type="button"
            @click="showCiudadDropdown = !showCiudadDropdown"
            class="flex w-full items-center justify-between rounded-2xl border border-slate-300 bg-white px-4 py-3 text-left text-plomo transition focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40"
            :class="[
              errors.ciudad ? 'border-gold focus:border-gold focus:ring-gold/40' : '',
              showCiudadDropdown ? 'border-gold ring-2 ring-gold/40' : ''
            ]"
          >
            <span class="flex items-center gap-2" :class="form.ciudad ? 'text-plomo' : 'text-slate-400'">
              <MapPinIcon class="h-5 w-5 shrink-0" />
              {{ form.ciudad ? (ciudadOptions.find((c) => c.value === form.ciudad)?.label || form.ciudad) : 'Seleccionar ciudad' }}
            </span>
            <ChevronDownIcon
              class="h-5 w-5 shrink-0 text-slate-400 transition-transform duration-200"
              :class="{ 'rotate-180 text-carmesi': showCiudadDropdown }"
            />
          </button>

          <Transition name="dropdown-fade">
            <ul
              v-if="showCiudadDropdown"
              class="absolute z-30 mt-2 max-h-64 w-full overflow-y-auto rounded-2xl border border-slate-200 bg-white p-1.5 shadow-2xl shadow-black/10"
            >
              <li v-for="city in ciudadOptions" :key="city.value">
                <button
                  type="button"
                  @click="selectCiudad(city.value)"
                  class="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm transition hover:bg-carmesi/10"
                  :class="form.ciudad === city.value ? 'bg-carmesi/10 font-semibold text-carmesi' : 'text-plomo'"
                >
                  <span>{{ city.label }}</span>
                  <CheckIcon v-if="form.ciudad === city.value" class="h-4 w-4 text-carmesi" />
                </button>
              </li>
            </ul>
          </Transition>

          <ErrorTooltip :message="errors.ciudad" />
        </div>
      </div>

      <div v-if="showUbicacionStep" class="relative">
        <button
          type="button"
          @click="openLocationModal"
          class="flex w-full items-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 py-3 text-left text-plomo transition focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40"
          :class="errors.ubicacion ? 'border-gold focus:border-gold focus:ring-gold/40' : ''"
        >
          <MapPinIconSolid class="h-5 w-5 shrink-0" :class="form.lat && form.lng ? 'text-carmesi' : 'text-slate-400'" />
          <span :class="form.lat && form.lng ? 'text-plomo' : 'text-slate-400'">
            {{ form.lat && form.lng ? 'Ubicación seleccionada' : 'Seleccionar ubicación' }}
          </span>
        </button>
        <ErrorTooltip :message="errors.ubicacion" />
      </div>

      <div v-if="showServiciosStep" class="relative pt-6 sm:pt-8">
        <label class="block text-base font-bold text-slate-400 text-center">
          Servicios
        </label>

        <div class="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4">
          <button
            v-for="s in serviciosList"
            :key="s"
            type="button"
            @click="toggleServicio(s)"
            :disabled="form.servicios.length >= 13 && !form.servicios.includes(s)"
            :class="{
              'bg-carmesi text-white border-carmesi': form.servicios.includes(s),
              'bg-white text-slate-400 border-slate-300 hover:bg-carmesi/10': !form.servicios.includes(s),
              'opacity-50 cursor-not-allowed': form.servicios.length >= 13 && !form.servicios.includes(s)
            }"
            class="w-full px-2 py-1.5 rounded-xl border text-[11px] sm:text-sm leading-tight font-medium lowercase text-center transition active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {{ s }}
          </button>
        </div>
        <ErrorTooltip :message="errors.servicios" />
      </div>

      <Teleport to="body">
        <div v-show="showLocationModal" class="fixed inset-0 z-10000 bg-white">
          <div id="rc-map" class="absolute inset-0"></div>
          <button
            type="button"
            class="absolute top-4 left-4 z-1100 inline-flex h-11 w-11 items-center justify-center rounded-full bg-white text-plomo shadow-lg transition active:scale-95 hover:bg-slate-100"
            @click="closeLocationModal"
            aria-label="Cerrar mapa"
          >
            <XMarkIcon class="w-6 h-6" />
          </button>
          <button
            v-if="form.lat && form.lng"
            type="button"
            class="absolute top-4 right-4 z-1100 rounded-full bg-carmesi px-5 py-3 text-sm font-semibold text-white shadow-lg transition active:scale-95 hover:bg-red-700"
            @click="closeLocationModal"
          >
            Confirmar
          </button>
        </div>
      </Teleport>

      <div v-if="showHorariosStep" class="relative pt-6 sm:pt-8">
        <label class="block text-base font-bold text-slate-400 text-center">
          Horarios
        </label>

        <div v-if="!sortedHorarios.length" class="mt-2 flex flex-nowrap items-center justify-center gap-1">
          <input
            v-model="horaInicioValue"
            type="number"
            min="1"
            max="12"
            placeholder="Hora"
            @input="horaInicioValue = clampHora(horaInicioValue)"
            class="w-16 shrink-0 rounded-xl border border-slate-300 bg-white px-1 py-1.5 text-center text-sm text-slate-800 focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40"
          />
          <div class="flex shrink-0 overflow-hidden rounded-xl border border-slate-300">
            <button
              type="button"
              @click="horaInicioPeriodo = horaInicioPeriodo === 'AM' ? null : 'AM'"
              class="px-1.5 py-1.5 text-xs font-semibold transition"
              :class="horaInicioPeriodo === 'AM' ? 'bg-carmesi text-white' : 'bg-white text-slate-400 hover:bg-carmesi/10'"
            >
              AM
            </button>
            <button
              type="button"
              @click="horaInicioPeriodo = horaInicioPeriodo === 'PM' ? null : 'PM'"
              class="border-l border-slate-300 px-1.5 py-1.5 text-xs font-semibold transition"
              :class="horaInicioPeriodo === 'PM' ? 'bg-carmesi text-white' : 'bg-white text-slate-400 hover:bg-carmesi/10'"
            >
              PM
            </button>
          </div>

          <span class="shrink-0 px-0.5 text-sm font-bold text-plomo">-</span>

          <input
            v-model="horaFinValue"
            type="number"
            min="1"
            max="12"
            placeholder="Hora"
            @input="horaFinValue = clampHora(horaFinValue)"
            @keyup.enter="addHoraManual"
            class="w-16 shrink-0 rounded-xl border border-slate-300 bg-white px-1 py-1.5 text-center text-sm text-slate-800 focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/40"
          />
          <div class="flex shrink-0 overflow-hidden rounded-xl border border-slate-300">
            <button
              type="button"
              @click="horaFinPeriodo = horaFinPeriodo === 'AM' ? null : 'AM'"
              class="px-1.5 py-1.5 text-xs font-semibold transition"
              :class="horaFinPeriodo === 'AM' ? 'bg-carmesi text-white' : 'bg-white text-slate-400 hover:bg-carmesi/10'"
            >
              AM
            </button>
            <button
              type="button"
              @click="horaFinPeriodo = horaFinPeriodo === 'PM' ? null : 'PM'"
              class="border-l border-slate-300 px-1.5 py-1.5 text-xs font-semibold transition"
              :class="horaFinPeriodo === 'PM' ? 'bg-carmesi text-white' : 'bg-white text-slate-400 hover:bg-carmesi/10'"
            >
              PM
            </button>
          </div>
        </div>

        <div v-if="sortedHorarios.length" class="mt-3 flex flex-wrap justify-center gap-1.5">
          <button
            v-for="h in sortedHorarios"
            :key="`${h.inicio}-${h.fin}`"
            type="button"
            @click="toggleHora(h)"
            class="flex items-center gap-1 px-2 py-1.5 rounded-lg border border-carmesi bg-carmesi text-sm font-medium text-white transition active:scale-95"
          >
            {{ formatHoraLabel(h) }}
            <XMarkIcon class="h-3.5 w-3.5" />
          </button>
        </div>

        <ErrorTooltip :message="errors.horarios" />
      </div>

      <div v-if="showPreciosStep" class="relative pt-6 sm:pt-8">
        <label class="block text-base font-bold text-slate-400 text-center">
          Precios
        </label>

        <div class="mt-2 flex flex-col items-center gap-2">
          <button
            v-for="preset in preciosPresets"
            :key="preset"
            type="button"
            @click="togglePrecioPreset(preset)"
            :class="form.precios.some((p) => p.tiempo === preset) ? 'bg-carmesi text-white border-carmesi' : 'bg-white text-slate-400 border-slate-300 hover:bg-carmesi/10'"
            class="w-full max-w-40 px-4 py-2 rounded-2xl border text-sm font-medium transition active:scale-95"
          >
            {{ preset }}
            <span
              v-if="getPrecioPreset(preset)"
              class="font-semibold underline decoration-dotted underline-offset-2"
              @click.stop="openPrecioEditor(preset)"
            >
              · {{ getPrecioPreset(preset) }} Bs
            </span>
          </button>
        </div>

        <div
          v-if="editingPrecioPreset && getPrecioObj(editingPrecioPreset)"
          class="mt-3 mx-auto flex w-full max-w-44 flex-wrap items-center gap-2 rounded-2xl border border-carmesi bg-carmesi/5 p-3"
        >
          <span class="flex-1 min-w-32 text-sm font-bold text-carmesi">
            {{ editingPrecioPreset }}
          </span>
          <div class="flex items-center gap-1 rounded-2xl border border-slate-300 bg-white px-3 py-2">
            <span class="text-sm font-semibold text-slate-600">Bs.</span>
            <input
              :ref="(el) => { if (el) precioInputRefs[editingPrecioPreset] = el }"
              v-model.number="getPrecioObj(editingPrecioPreset).precio"
              type="number"
              min="0"
              inputmode="decimal"
              @blur="closePrecioEditor(editingPrecioPreset)"
              @keyup.enter="closePrecioEditor(editingPrecioPreset)"
              class="w-16 rounded-lg border-0 bg-transparent px-1 py-0.5 text-slate-800 focus:outline-none focus:ring-0"
            />
          </div>
        </div>
        <ErrorTooltip :message="errors.precios" />
      </div>

      <div v-if="showFotosStep" class="relative pt-6 sm:pt-8">
        <label class="block text-base font-bold text-slate-400 text-center">Fotos</label>
        <div
          class="mt-2 rounded-2xl border border-dashed p-4 transition text-center"
          :class="
            dragActive
              ? 'border-carmesi bg-carmesi/10'
              : 'border-slate-300 bg-slate-50'
          "
          @dragenter.prevent="onDragOver"
          @dragover.prevent="onDragOver"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="onDrop"
        >
          <label
            class="inline-flex items-center gap-3 cursor-pointer rounded-full bg-carmesi px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-700"
          >
            <span>Elegir archivos</span>
            <input
              type="file"
              accept="image/*"
              multiple
              @change="onFilesSelected"
              class="hidden"
            />
          </label>

          <div class="mt-3 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            <div
              v-for="(ph, i) in form.photos"
              :key="ph.id"
              class="relative self-start rounded-lg overflow-hidden shadow-md group"
            >
              <div
                v-if="ph.id === coverPhotoId"
                class="relative w-full overflow-hidden"
                data-cover-crop-box
              >
                <!-- Sin object-cover ni alto fijo: la foto se muestra completa,
                     a su proporción real (block h-auto w-full), para que el
                     porcentaje que se arrastra acá coincida exactamente con
                     el que usa el servidor para recortar la miniatura sobre
                     la foto original completa (antes, al mostrarla recortada
                     en una caja de 224px, el punto elegido en el editor no
                     coincidía con el resultado final). -->
                <img
                  :src="ph.url || '/placeholder-image.svg'"
                  class="block h-auto w-full pointer-events-none"
                  @error="(event) => { event.target.src = '/placeholder-image.svg' }"
                />
                <!-- Círculo de recorte: se arrastra libremente, siguiendo al
                     mouse/dedo, para elegir qué parte de la foto queda
                     dentro y se usa como portada circular en el homepage.
                     El resto se oscurece con un box-shadow enorme en vez de
                     duplicar la imagen, así siempre queda perfectamente
                     alineado con la foto real de abajo. El arrastre (ver
                     startCoverFocalDrag) limita el recorrido para que el
                     círculo nunca se salga de los bordes de la foto. -->
                <div
                  data-cover-crop-circle
                  class="pointer-events-none absolute left-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-gold"
                  :style="{ top: coverFocalY + '%', boxShadow: '0 0 0 9999px rgba(0,0,0,0.6)' }"
                ></div>
                <div
                  class="absolute inset-0 touch-none select-none"
                  :class="isDraggingCoverFocal ? 'cursor-grabbing' : 'cursor-grab'"
                  @pointerdown="startCoverFocalDrag($event)"
                ></div>
              </div>
              <img
                v-else
                :src="ph.url || '/placeholder-image.svg'"
                class="w-full h-32 object-cover pointer-events-none"
                @error="(event) => { event.target.src = '/placeholder-image.svg' }"
              />

              <button
                type="button"
                @click.stop="setCoverPhoto(i)"
                class="absolute top-1 left-1 z-20 flex h-7 w-7 items-center justify-center rounded-full bg-black/50 transition hover:bg-black/70"
                :aria-label="ph.id === coverPhotoId ? 'Foto de portada' : 'Marcar como portada'"
                :title="ph.id === coverPhotoId ? 'Foto de portada' : 'Marcar como portada'"
              >
                <StarIcon v-if="ph.id === coverPhotoId" class="h-4 w-4 text-yellow-400" />
                <StarIconOutline v-else class="h-4 w-4 text-white" />
              </button>

              <div class="pointer-events-none absolute inset-0 z-10 flex items-center justify-center">
                <button
                  type="button"
                  data-photo-delete
                  @click.stop="removePhoto(i)"
                  class="pointer-events-auto flex h-9 w-9 items-center justify-center rounded-full bg-black/50 transition hover:bg-black/70"
                  aria-label="Eliminar foto"
                >
                  <TrashIcon class="h-5 w-5 text-white" />
                </button>
              </div>
            </div>
          </div>

          <div class="text-xs text-slate-500 sm:text-plomo/70 mt-1">
            {{
              coverPhotoId
                ? "Arrastrá la foto dentro del círculo para elegir qué parte se ve en el homepage"
                : "Toca la estrella para elegir la foto de portada"
            }}
          </div>
        </div>
        <ErrorTooltip :message="errors.photos" />
      </div>

      <div class="flex items-center justify-between px-10 sm:px-16 pt-6 sm:pt-8">
        <button type="button" @click="cancel" class="block text-sm font-medium text-plomo">
          Cancelar
        </button>
        <button
          v-if="showSubmitStep"
          type="submit"
          :disabled="isSubmittingClient"
          class="bg-carmesi text-white px-4 py-2 rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
        >
          {{ isSubmittingClient ? "Guardando..." : "Guardar" }}
        </button>
      </div>
    </form>

    <!-- Toast elegante (reemplaza los alert() nativos) -->
    <Teleport to="body">
      <transition name="toast-slide">
        <div v-if="toast.show" class="app-toast" :class="toast.type === 'error' ? 'app-toast-error' : 'app-toast-success'">
          <div class="app-toast-icon">
            {{ toast.type === 'error' ? '!' : '✓' }}
          </div>
          <div class="app-toast-body">
            <p class="app-toast-title">{{ toast.title }}</p>
            <p v-if="toast.message" class="app-toast-message">{{ toast.message }}</p>
            <ul v-if="toast.items && toast.items.length" class="app-toast-list">
              <li v-for="item in toast.items" :key="item">{{ item }}</li>
            </ul>
          </div>
          <button type="button" class="app-toast-close" @click="closeToast">✕</button>
        </div>
      </transition>
    </Teleport>

    <Teleport to="body">
      <transition name="toast-slide">
        <div
          v-if="showPricingModal"
          class="fixed inset-0 z-10000 flex items-center justify-center overflow-y-auto bg-black/75 p-4 backdrop-blur-sm"
          @click.self="closePricingModal"
        >
          <div class="max-h-[90vh] w-full max-w-sm overflow-y-auto rounded-[1.75rem] border border-slate-200 bg-white shadow-2xl shadow-black/40">
            <div v-if="!selectedPricingOption" class="p-5 pt-6 sm:p-6 sm:pt-8">
              <div v-if="pricingLoading" class="rounded-2xl border border-slate-200 bg-slate-50 p-5 text-slate-600">
                Cargando precios de publicación...
              </div>

              <div v-else-if="pricingError" class="rounded-2xl border border-red-200 bg-red-50 p-5 text-red-700">
                {{ pricingError }}
              </div>

              <div v-else-if="pricingOptions.length === 0" class="rounded-2xl border border-slate-200 bg-slate-50 p-5 text-slate-600">
                No hay planes de publicación disponibles.
              </div>

              <div v-else class="space-y-3">
                <button
                  v-for="option in pricingOptions"
                  :key="option.id"
                  type="button"
                  class="w-full rounded-2xl border p-4 text-left transition"
                  :class="selectedPricingOption && selectedPricingOption.id === option.id
                    ? 'border-carmesi bg-white shadow-[0_0_0_1px_rgba(220,38,38,0.2)]'
                    : 'border-slate-200 bg-white hover:border-carmesi/40 hover:bg-carmesi/5'"
                  @click="selectPricingOption(option)"
                >
                  <div class="flex items-center justify-between gap-4">
                    <p class="text-sm font-semibold uppercase tracking-[0.2em] text-plomo">{{ option.daysLabel }}</p>
                    <span class="rounded-full border border-carmesi/30 bg-carmesi/10 px-3 py-1 text-sm font-bold text-carmesi">
                      {{ option.amountLabel || 'Consultar' }}
                    </span>
                  </div>
                </button>
              </div>
            </div>

            <div v-else class="p-5 pt-6 sm:p-6 sm:pt-8">
              <div class="space-y-3 rounded-3xl border border-slate-200 bg-white p-5">
                <div class="flex min-h-48 items-center justify-center p-4">
                  <div
                    v-if="selectedPricingOption.qrImage"
                    class="w-56 overflow-hidden rounded-2xl bg-white p-3 shadow-lg sm:w-72"
                    style="aspect-ratio: 1027 / 1190;"
                  >
                    <img
                      :src="selectedPricingOption.qrImage"
                      alt="QR de pago"
                      class="h-full w-full object-cover object-top"
                    />
                  </div>
                  <p v-else class="max-w-sm text-center text-sm text-slate-500">
                    Selecciona una opción para generar el QR.
                  </p>
                </div>

                <div class="flex flex-col items-center gap-3">
                  <button
                    v-if="!qrDownloaded"
                    type="button"
                    class="animate-pulse rounded-full bg-carmesi px-6 py-3.5 text-base font-bold text-white shadow-lg shadow-carmesi/40 transition hover:bg-red-700"
                    @click="downloadSelectedQr"
                  >
                    Descargar QR y pagar
                  </button>
                  <button
                    v-if="qrDownloaded"
                    type="button"
                    class="flex items-center gap-1.5 rounded-full border border-red-300/40 bg-red-50 px-5 py-2.5 text-sm font-semibold text-red-600 transition hover:bg-red-100"
                    @click="openComprobanteModal"
                  >
                    <NewspaperIcon class="h-4 w-4 shrink-0" />
                    {{ comprobanteFile ? "comprobante cargado" : "cargar comprobante" }}
                  </button>
                </div>
              </div>

              <div class="mt-4 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
                <button
                  v-if="comprobanteSent"
                  type="button"
                  class="rounded-full bg-carmesi px-5 py-3 text-sm font-bold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
                  :disabled="!selectedPricingOption || pricingLoading"
                  @click="confirmPaymentAndSave"
                >
                  Confirmar pago
                </button>
                <button
                  type="button"
                  class="rounded-full border border-slate-300 bg-slate-100 px-5 py-3 text-sm font-semibold text-plomo transition hover:bg-slate-200"
                  @click="closePricingModal"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </Teleport>

    <Teleport to="body">
      <transition name="toast-slide">
        <div
          v-if="showComprobanteModal"
          class="fixed inset-0 z-10000 flex items-center justify-center bg-black/75 p-4 backdrop-blur-sm"
          @click.self="closeComprobanteModal"
        >
          <div class="w-full max-w-sm overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-2xl shadow-black/40">
            <div class="flex items-center justify-between border-b border-slate-200 px-5 py-4">
              <h3 class="text-base font-bold text-plomo">Cargar comprobante</h3>
              <button
                type="button"
                class="rounded-full border border-slate-300 bg-slate-100 px-3 py-1.5 text-sm font-medium text-plomo transition hover:bg-slate-200"
                @click="closeComprobanteModal"
              >
                Cerrar
              </button>
            </div>

            <div class="space-y-4 p-5">
              <div v-if="comprobantePreviewUrl" class="relative">
                <img
                  :src="comprobantePreviewUrl"
                  alt="Comprobante de pago"
                  class="max-h-72 w-full rounded-2xl border border-slate-200 object-contain"
                />
                <button
                  type="button"
                  class="absolute right-2 top-2 rounded-full bg-black/60 p-1.5 text-white transition hover:bg-black/80"
                  aria-label="Quitar comprobante"
                  @click="removeComprobanteFile"
                >
                  <XMarkIcon class="h-4 w-4" />
                </button>
              </div>

              <label
                class="flex cursor-pointer flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-carmesi/40 bg-carmesi/5 px-4 py-6 text-center transition hover:bg-carmesi/10"
              >
                <span class="text-sm font-semibold text-carmesi">
                  {{ comprobanteFile ? "Cambiar imagen" : "Elegir imagen del comprobante" }}
                </span>
                <input type="file" accept="image/*" class="hidden" @change="onComprobanteFileSelected" />
              </label>

              <button
                type="button"
                class="w-full rounded-full bg-carmesi px-5 py-3 text-sm font-bold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
                :disabled="!comprobanteFile"
                @click="saveComprobante"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </transition>
    </Teleport>
  </section>
</template>

<script>
export default {};
</script>

<script setup>
/* global L */
import { reactive, onMounted, onUnmounted, ref, watch, computed, nextTick } from "vue";
import { useRoute } from "vue-router";
import router from "../router";
import api, { postCliente } from "../services/api";
import { MapPinIcon, XMarkIcon, ChevronDownIcon, CheckIcon, TrashIcon, StarIcon as StarIconOutline } from "@heroicons/vue/24/outline";
import { MapPinIcon as MapPinIconSolid, NewspaperIcon, StarIcon } from "@heroicons/vue/24/solid";
import qrPlan200 from "../assets/200.jpeg";
import qrPlan400 from "../assets/400.jpeg";
import ErrorTooltip from "./ErrorTooltip.vue";
import { getFlag } from "../services/flags";

const route = useRoute();
const serviciosList = ref([]);
// Guarda la promesa de loadServicios() (disparada en onMounted) para que
// loadExistingClientData() pueda esperarla antes de reconciliar los
// servicios guardados del cliente contra el catálogo (ver
// reconcileServiciosWithCatalog).
let serviciosLoadPromise = Promise.resolve();
const isEditMode = computed(() => route.query?.edit === "1" || route.query?.mode === "edit");
const editingClientId = computed(() => {
  const fromQuery = route.query?.id || route.params?.id || "";
  if (fromQuery) return String(fromQuery);

  try {
    const pending = JSON.parse(sessionStorage.getItem("pendingEditClient") || "{}") || {};
    return String(pending?.id || pending?.card?.clientId || pending?.card?.id || "");
  } catch {
    return "";
  }
});
const CIUDAD_COORDS = {
  Cochabamba: [-17.3936, -66.157],
  "La Paz": [-16.4897, -68.1193],
  "Santa Cruz": [-17.7833, -63.1821],
  Chuquisaca: [-19.0433, -65.2592],
  Beni: [-14.0, -65.0],
  Pando: [-11.3333, -67.6667],
  Tarija: [-21.5355, -64.7296],
  Oruro: [-17.9715, -67.0932],
  Potosi: [-19.5836, -65.7531],
};
const preciosPresets = ["1 hora", "30 min", "15 min", "Salida"];
const precioInputRefs = {};
const horaInicioValue = ref("");
const horaInicioPeriodo = ref(null);
const horaFinValue = ref("");
const horaFinPeriodo = ref(null);
const editingPrecioPreset = ref(null);
const showLocationModal = ref(false);
const dragActive = ref(false);
// Portada: se guarda por id de foto (no por posición) para que elegirla no
// mueva las miniaturas en pantalla; el reordenamiento real (portada primero)
// se arma solo al construir el payload de envío, ver buildOrderedPhotos().
let photoIdCounter = 0;
const coverPhotoId = ref(null);
// Punto focal vertical de la portada (0 = borde superior, 100 = borde
// inferior, 50 = centrado) dentro del círculo con el que se recorta la foto
// en el homepage. Se arrastra con el mouse/dedo directamente sobre la foto.
const coverFocalY = ref(50);
const isDraggingCoverFocal = ref(false);
const showTipoOptions = ref(false);
const tipoDropdownRef = ref(null);
const tipoLocalOptions = ["Independiente", "Night Club"];
const showNacionalidadDropdown = ref(false);
const nacionalidadDropdownRef = ref(null);
const nacionalidadOptions = [
  "Albanesa",
  "Alemana",
  "Árabe",
  "Argentina",
  "Australiana",
  "Austriaca",
  "Bangladesí",
  "Belga",
  "Boliviana",
  "Bosnia",
  "Brasileña",
  "Búlgara",
  "Canadiense",
  "Checa",
  "Chilena",
  "China",
  "Colombiana",
  "Costarricense",
  "Croata",
  "Cubana",
  "Danesa",
  "Dominicana",
  "Ecuatoriana",
  "Española",
  "Estadounidense",
  "Estonia",
  "Filipina",
  "Finlandesa",
  "Francesa",
  "Griega",
  "Guatemalteca",
  "Haitiana",
  "Holandesa",
  "Hondureña",
  "Húngara",
  "India",
  "Indonesa",
  "Inglesa",
  "Irlandesa",
  "Italiana",
  "Jamaicana",
  "Japonesa",
  "Keniana",
  "Letona",
  "Lituana",
  "Malaya",
  "Maldiva",
  "Marroquí",
  "Mexicana",
  "Moldava",
  "Neozelandesa",
  "Nicaragüense",
  "Nigeriana",
  "Noruega",
  "Pakistaní",
  "Panameña",
  "Paraguaya",
  "Peruana",
  "Polaca",
  "Portuguesa",
  "Rumana",
  "Rusa",
  "Senegalesa",
  "Serbia",
  "Singapurense",
  "Sudafricana",
  "Sueca",
  "Suiza",
  "Tailandesa",
  "Tunecina",
  "Turca",
  "Ucraniana",
  "Uruguaya",
  "Venezolana",
  "Vietnamita",
];
const showCiudadDropdown = ref(false);
const ciudadDropdownRef = ref(null);
const ciudadOptions = [
  { value: "Beni", label: "Beni" },
  { value: "Chuquisaca", label: "Sucre" },
  { value: "Cochabamba", label: "Cochabamba" },
  { value: "La Paz", label: "La Paz" },
  { value: "Oruro", label: "Oruro" },
  { value: "Pando", label: "Pando" },
  { value: "Potosi", label: "Potosí" },
  { value: "Santa Cruz", label: "Santa Cruz" },
  { value: "Tarija", label: "Tarija" },
];

let map = null;
let marker = null;

const form = reactive({
  nombre: "",
  edad: null,
  nacionalidad: "", // 🔧 antes decía "pais" y nunca se usaba, causaba que nacionalidad nunca se guardara
  ciudad: "",
  tipoLocal: "",
  photos: [],
  telefono: "591",
  telefonoVisible: "",
  servicios: [],
  lat: null,
  lng: null,
  horarios: [],
  precios: [],
  disponibleAhora: false,
});

const errors = reactive({
  tipoLocal:"",
  nombre: "",
  nacionalidad: "",
  ciudad: "",
  telefono: "",
  edad: "",
  servicios: "",
  ubicacion: "",
  horarios: "",
  precios: "",
  photos: "",
});

// ---------- Formulario completo (sin despliegue en cascada) ----------
// Todos los campos se muestran de una vez, tanto al crear como al editar.
const isFlowGated = computed(() => false);
const nombreDone = computed(() => form.nombre.trim() !== "");
const edadDone = computed(
  () => form.tipoLocal === "Night Club" || (form.edad !== null && form.edad !== "" && Number(form.edad) >= 18 && Number(form.edad) <= 99)
);
const telefonoDone = computed(() => form.telefono !== "" && form.telefono.length >= 10);
const nacionalidadDone = computed(() => form.tipoLocal === "Night Club" || form.nacionalidad !== "");
const ciudadDone = computed(() => form.ciudad !== "");
const serviciosDone = computed(() => form.servicios.length > 0);
const ubicacionDone = computed(() => !!form.lat && !!form.lng);
const horariosDone = computed(() => form.horarios.length > 0);
const sortedHorarios = computed(() => [...form.horarios].sort((a, b) => a.inicio - b.inicio));
const preciosDone = computed(
  () => form.precios.length > 0 && !form.precios.some((p) => !p.precio || p.precio <= 0)
);
const fotosDone = computed(() => form.photos.length > 0);

const showNombreStep = computed(() => !isFlowGated.value || !!form.tipoLocal);
const showEdadStep = computed(() => !isFlowGated.value || nombreDone.value);
const showContactoStep = computed(
  () => !isFlowGated.value || (form.tipoLocal === "Night Club" ? nombreDone.value : edadDone.value)
);
const showNacionalidadCiudadStep = computed(() => !isFlowGated.value || telefonoDone.value);
const showCiudadField = computed(() => !isFlowGated.value || nacionalidadDone.value);
const showServiciosStep = computed(() => !isFlowGated.value || ciudadDone.value);
const showUbicacionStep = computed(() => !isFlowGated.value || serviciosDone.value);
const showHorariosStep = computed(() => !isFlowGated.value || ubicacionDone.value);
const showPreciosStep = computed(() => !isFlowGated.value || horariosDone.value);
const showFotosStep = computed(() => !isFlowGated.value || preciosDone.value);
const showSubmitStep = computed(() => !isFlowGated.value || fotosDone.value);

const showPricingModal = ref(false);
const pricingLoading = ref(false);
const pricingError = ref("");
const comprobanteSent = ref(false);
const qrDownloaded = ref(false);
const showComprobanteModal = ref(false);
const comprobanteFile = ref(null);
const comprobantePreviewUrl = ref("");
const defaultPricingOptions = [
  {
    id: "plan-200",
    title: "VIP",
    description: "Plan básico de publicación",
    daysCount: 3,
    daysLabel: "3 días",
    amountValue: 200,
    amountLabel: "Bs 200",
    qrImage: qrPlan200,
    qrText: "PLAN-200",
    raw: { id_precio_publicacion: 1, precio: 200, numero_dias: 3, descripcion: "VIP", estado: "ACTIVO" },
  },
  {
    id: "plan-400",
    title: "PREMIUM",
    description: "Plan destacado de publicación",
    daysCount: 7,
    daysLabel: "7 días",
    amountValue: 400,
    amountLabel: "Bs 400",
    qrImage: qrPlan400,
    qrText: "PLAN-400",
    raw: { id_precio_publicacion: 2, precio: 400, numero_dias: 7, descripcion: "PREMIUM", estado: "ACTIVO" },
  },
];
const pricingOptions = ref([...defaultPricingOptions]);
const selectedPricingOption = ref(null);
const pendingCreateSubmission = ref(false);
// Evita que un doble tap/click en "Guardar" (frecuente en móvil) dispare dos
// submitClient() en paralelo y cree la publicación duplicada en el backend.
const isSubmittingClient = ref(false);

// ---------- Toast elegante ----------
const toast = reactive({
  show: false,
  type: "error", // "error" | "success"
  title: "",
  message: "",
  items: [],
});
let toastTimer = null;

function showToast({ type = "error", title = "", message = "", items = [], duration = 5000 }) {
  clearTimeout(toastTimer);
  toast.type = type;
  toast.title = title;
  toast.message = message;
  toast.items = items;
  toast.show = true;
  toastTimer = setTimeout(() => {
    toast.show = false;
  }, duration);
}

function closeToast() {
  clearTimeout(toastTimer);
  toast.show = false;
}

const FIELD_LABELS = {
  tipoLocal: "Tipo de local (Independiente/Night Club)",
  nombre: "Nombre",
  nacionalidad: "Nacionalidad",
  ciudad: "Ciudad",
  telefono: "Contacto (WhatsApp)",
  edad: "Edad",
  servicios: "Tipos de servicio",
  ubicacion: "Ubicación en el mapa",
  horarios: "Horarios de atención",
  precios: "Precios",
  photos: "Fotos",
};

function getMissingFieldLabels() {
  return Object.entries(errors)
    .filter(([, msg]) => !!msg)
    .map(([key]) => FIELD_LABELS[key] || key);
}

function normalizeTextList(value) {
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === "string") return item;
        return item?.descripcion || item?.description || item?.nombre || item?.name || "";
      })
      .map((item) => String(item || "").trim())
      .filter(Boolean);
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return normalizeTextList(parsed);
    } catch {
      return value
        .split(/[\n,;]+/)
        .map((item) => item.trim())
        .filter(Boolean);
    }
  }

  return [];
}

// Los servicios de una publicación se guardan como texto suelto (copiado del
// catálogo al momento de elegirlos, no por id, ver contenidoControladores.js),
// así que con el tiempo algunas publicaciones viejas terminan con entradas
// que ya no coinciden con el catálogo actual: un servicio renombrado/borrado
// (queda huérfano, no coincide con ningún botón), o solo con diferencias de
// mayúsculas/espacios (ej. "TRATO DE NOVIOS" guardado vs "trato de novios"
// del catálogo hoy). Esas entradas no se pintan como seleccionadas en
// ningún botón (el match es exacto), pero SÍ seguían contando para el tope
// de 13, así que un cliente con 2 entradas huérfanas solo podía elegir 11
// servicios visibles antes de toparse con el límite sin explicación.
// Acá reconciliamos contra el catálogo actual: las que matchean (ignorando
// mayúsculas/espacios) se normalizan a la grafía exacta del catálogo (para
// que sí se vean marcadas), y las huérfanas se descartan.
function reconcileServiciosWithCatalog(list) {
  const catalog = serviciosList.value || [];
  // Si el catálogo todavía no cargó (carrera con loadServicios), no filtramos
  // para no perder datos reales por una casualidad de timing.
  if (!catalog.length) return list;

  const normalize = (value) => String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
  const canonicalByNormalized = new Map(catalog.map((item) => [normalize(item), item]));

  const seen = new Set();
  const result = [];
  for (const item of list) {
    const canonical = canonicalByNormalized.get(normalize(item));
    if (canonical && !seen.has(canonical)) {
      seen.add(canonical);
      result.push(canonical);
    }
  }
  return result;
}

function resolveImageUrl(url) {
  if (!url) return "";
  if (typeof url !== "string") return "";
  if (url.startsWith("data:") || /^https?:\/\//i.test(url)) return url;

  const baseUrl = api.defaults?.baseURL || "";
  if (!baseUrl) return url;

  return `${baseUrl.replace(/\/$/, "")}/${String(url).replace(/^\//, "")}`;
}

function normalizeImages(value) {
  if (Array.isArray(value)) {
    return value.flatMap((item) => normalizeImages(item));
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];

    try {
      const parsed = JSON.parse(trimmed);
      return normalizeImages(parsed);
    } catch {
      return trimmed ? [trimmed] : [];
    }
  }

  if (value && typeof value === "object") {
    const direct = value?.url || value?.secure_url || value?.path || value?.imageUrl || value?.image_url || value?.src || value?.href || "";
    if (direct) return normalizeImages(direct);

    const nestedValues = Object.keys(value)
      .filter((key) => /image|img|foto|photo|src|url/i.test(key))
      .map((key) => normalizeImages(value[key]))
      .flat();

    if (nestedValues.length) return nestedValues;

    return [];
  }

  return [];
}

function normalizeHorarios(value) {
  if (!value) return [];

  const rawItems = Array.isArray(value) ? value : [value];
  const rangos = rawItems
    .map((item) => {
      if (typeof item === "string") {
        const matches = item.match(/(\d{1,2}):\d{2}/g) || [];
        const inicio = matches[0] ? Number(matches[0].split(":")[0]) : null;
        const fin = matches[1] ? Number(matches[1].split(":")[0]) : inicio;
        return Number.isInteger(inicio) ? { inicio, fin: Number.isInteger(fin) ? fin : inicio } : null;
      }

      if (item && typeof item === "object") {
        const rawInicio = item.hora_inicio || item.horaInicio || item.start || item.inicio || item.desde || "";
        const rawFin = item.hora_fin || item.horaFin || item.end || item.fin || item.hasta || "";
        const matchInicio = String(rawInicio).match(/(\d{1,2}):\d{2}/);
        const matchFin = String(rawFin).match(/(\d{1,2}):\d{2}/);
        const inicio = matchInicio ? Number(matchInicio[1]) : null;
        const fin = matchFin ? Number(matchFin[1]) : inicio;
        return Number.isInteger(inicio) ? { inicio, fin: Number.isInteger(fin) ? fin : inicio } : null;
      }

      return null;
    })
    .filter((r) => r && r.inicio >= 0 && r.inicio <= 23 && r.fin >= 0 && r.fin <= 23);

  return rangos.sort((a, b) => a.inicio - b.inicio);
}

function padHour(h) {
  return String(h).padStart(2, "0");
}

function formatHora12(h) {
  const period = h < 12 ? "am" : "pm";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}${period}`;
}

function formatHoraLabel(rango) {
  if (!rango) return "";
  return `${formatHora12(rango.inicio)} - ${formatHora12(rango.fin)}`;
}

function buildHorariosPayload() {
  return form.horarios
    .slice()
    .sort((a, b) => a.inicio - b.inicio)
    .map((r) => ({
      hora_inicio: `${padHour(r.inicio)}:00`,
      hora_fin: `${padHour(r.fin)}:00`,
    }));
}

function normalizePrecios(value) {
  if (!value) return [];

  const rawItems = Array.isArray(value) ? value : [value];
  return rawItems
    .map((item) => {
      if (typeof item === "string") {
        return { tiempo: item, precio: 0 };
      }

      if (item && typeof item === "object") {
        return {
          tiempo: item.tiempo || item.duration || item.label || "",
          precio: item.precio ?? item.price ?? 0,
        };
      }

      return null;
    })
    .filter((item) => item && item.tiempo);
}

function formatDateTimeLocalSQL(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
}

function formatTimestampForBackend(date) {
  // El backend convierte a UTC antes de guardar timestamp without time zone.
  // Restamos el offset local para que en BD quede la misma fecha/hora "visual" local.
  const adjusted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return formatDateTimeLocalSQL(adjusted);
}

function extractCreatedClientId(response) {
  const payload = response?.data;
  const direct = payload?.id_cliente ?? payload?.idCliente ?? payload?.id ?? null;
  if (direct != null && String(direct).trim() !== "") return String(direct);

  if (Array.isArray(payload) && payload.length > 0) {
    const first = payload[0] || {};
    const firstId = first?.id_cliente ?? first?.idCliente ?? first?.id ?? null;
    if (firstId != null && String(firstId).trim() !== "") return String(firstId);
  }

  const nested = payload?.data || payload?.value || payload?.cliente || null;
  if (Array.isArray(nested) && nested.length > 0) {
    const firstNested = nested[0] || {};
    const firstNestedId = firstNested?.id_cliente ?? firstNested?.idCliente ?? firstNested?.id ?? null;
    if (firstNestedId != null && String(firstNestedId).trim() !== "") return String(firstNestedId);
  }

  const nestedId = nested?.id_cliente ?? nested?.idCliente ?? nested?.id ?? null;
  if (nestedId != null && String(nestedId).trim() !== "") return String(nestedId);

  return "";
}

async function registerInitialVigenciaWindow({ clientId }) {
  if (!clientId) return;

  await api.put(`/clientes/${clientId}/fecha-vigencia`, {
    estado_pago: "PENDIENTE",
  });
}

// El botón/gesto "atrás" del celular, sin esta entrada de historial extra,
// navegaba fuera de /registro-cliente mientras el modal de QR estaba
// abierto, desmontando el componente y perdiendo todo el formulario
// llenado. Empujamos una marca (?pricingModal=1) igual que hace App.vue con
// su modal de servicios, así "atrás" solo cierra el modal.
function closePricingModal() {
  if (route.query.pricingModal) {
    router.back();
  } else {
    hidePricingModal();
  }
}

function hidePricingModal() {
  showPricingModal.value = false;
  pricingError.value = "";
  pendingCreateSubmission.value = false;
}

watch(
  () => route.query.pricingModal,
  (pricingModal) => {
    if (pricingModal || !showPricingModal.value) return;
    hidePricingModal();
  }
);

async function loadPricingOptions() {
  pricingLoading.value = true;
  pricingError.value = "";

  try {
    const response = await api.get("/contenidos/precio-publicacion");
    const payload = response?.data;
    const extracted = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.value)
        ? payload.value
        : Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload?.items)
            ? payload.items
            : payload
              ? [payload]
              : [];

    const mapped = extracted
      .map((item) => {
        if (!item || typeof item !== "object") return null;

        const status = String(item.estado ?? item.status ?? "").toUpperCase();
        if (status && status !== "ACTIVO") return null;

        const amount = Number(item.precio ?? item.price ?? item.monto ?? item.amount ?? 0);
        const days = Number.parseInt(item.numero_dias ?? item.numeroDias ?? item.dias ?? item.days ?? 1, 10);
        const backendPlanName = String(item.descripcion ?? item.description ?? item.nombre ?? item.name ?? "").trim();
        const qrFromBackend = resolveImageUrl(item.qr_url ?? item.qrUrl ?? "");
        const qrImage = qrFromBackend || (amount === 200 ? qrPlan200 : amount === 400 ? qrPlan400 : "");

        return {
          id: String(item.id_precio_publicacion ?? item.idPrecioPublicacion ?? item.id ?? `plan-${amount || "custom"}`),
          title: backendPlanName || `Plan Bs ${amount || "-"}`,
          description: backendPlanName ? `Plan de publicación ${backendPlanName}` : `Plan de publicación ${amount ? `Bs ${amount}` : ""}`,
          daysCount: Number.isFinite(days) && days > 0 ? days : 1,
          daysLabel: `${Number.isFinite(days) && days > 0 ? days : 1} día${Number.isFinite(days) && days > 1 ? "s" : ""}`,
          amountValue: Number.isFinite(amount) && amount > 0 ? amount : null,
          amountLabel: Number.isFinite(amount) && amount > 0 ? `Bs ${amount}` : "Consultar",
          qrImage,
          qrText: String(item.descripcion ?? item.description ?? `PLAN-${amount || "PAGO"}`),
          raw: item,
        };
      })
      .filter(Boolean)
      .sort((a, b) => (a.amountValue || 0) - (b.amountValue || 0));

    pricingOptions.value = mapped.length ? mapped : [...defaultPricingOptions];
  } catch (error) {
    console.error("Error cargando precio-publicacion:", error);
    pricingError.value = "No se pudieron cargar los planes del servidor. Se muestran planes por defecto.";
    pricingOptions.value = [...defaultPricingOptions];
  } finally {
    pricingLoading.value = false;
  }
}

async function openPricingModal() {
  if (isEditMode.value) return;

  pendingCreateSubmission.value = false;
  selectedPricingOption.value = null;
  qrDownloaded.value = false;
  showPricingModal.value = true;
  router.push({ query: { ...route.query, pricingModal: "1" } }).catch(() => {});
  await loadPricingOptions();
}

async function selectPricingOption(option) {
  selectedPricingOption.value = option;
  qrDownloaded.value = false;
}

function triggerDownload(href, filename) {
  const link = document.createElement("a");
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

async function downloadSelectedQr() {
  const plan = selectedPricingOption.value;
  if (!plan?.qrImage) return;

  const filename = `qr-${plan.id}.jpeg`;

  // El atributo "download" de un <a> solo lo respetan los navegadores de
  // forma confiable cuando el archivo es del mismo origen (nuestros QR
  // locales en assets/). Cuando el QR viene del backend (otro origen/puerto),
  // Chrome/Firefox/Android suelen ignorar "download" y simplemente abren la
  // imagen en vez de guardarla. Para que la descarga funcione igual en esos
  // casos, primero traemos la imagen como blob y descargamos esa copia local
  // (mismo origen, blob:), que sí dispara la descarga en todos lados.
  try {
    const response = await fetch(plan.qrImage, { mode: "cors" });
    if (!response.ok) throw new Error("No se pudo obtener el QR");
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    triggerDownload(blobUrl, filename);
    // Revocar de inmediato puede cortar la descarga a mitad de camino en
    // algunos navegadores/dispositivos, ya que guardar el archivo ocurre de
    // forma asíncrona después del click. Le damos un respiro antes de liberar
    // la URL del blob.
    setTimeout(() => URL.revokeObjectURL(blobUrl), 4000);
  } catch (err) {
    console.error("Error al descargar el QR como blob, se intenta descarga directa:", err);
    // Último recurso: si el fetch falla (ej. sin conexión, CORS bloqueado),
    // al menos abrimos la imagen para que el usuario pueda guardarla a mano
    // (mantener presionado > "Guardar imagen"), en vez de que no pase nada.
    try {
      triggerDownload(plan.qrImage, filename);
    } catch {
      window.open(plan.qrImage, "_blank");
    }
  }

  qrDownloaded.value = true;
}

function openComprobanteModal() {
  showComprobanteModal.value = true;
}

function closeComprobanteModal() {
  showComprobanteModal.value = false;
}

function saveComprobante() {
  if (!comprobanteFile.value) return;
  comprobanteSent.value = true;
  showComprobanteModal.value = false;
}

function onComprobanteFileSelected(e) {
  const file = (e.target.files || [])[0];
  e.target.value = null;
  if (!file || !file.type.startsWith("image/")) return;

  if (comprobantePreviewUrl.value) {
    URL.revokeObjectURL(comprobantePreviewUrl.value);
  }

  comprobanteFile.value = file;
  comprobantePreviewUrl.value = URL.createObjectURL(file);
}

function removeComprobanteFile() {
  if (comprobantePreviewUrl.value) {
    URL.revokeObjectURL(comprobantePreviewUrl.value);
  }
  comprobanteFile.value = null;
  comprobantePreviewUrl.value = "";
  comprobanteSent.value = false;
}

async function confirmPaymentAndSave() {
  if (!selectedPricingOption.value) return;

  pendingCreateSubmission.value = true;
  showPricingModal.value = false;
  if (route.query.pricingModal) {
    const { pricingModal, ...rest } = route.query;
    router.replace({ query: rest }).catch(() => {});
  }
  await submitClient();
}

function normalizeTelefono(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (!digits) {
    return { telefono: "", telefonoVisible: "" };
  }

  if (digits.startsWith("591") && digits.length > 3) {
    return {
      telefono: digits,
      telefonoVisible: digits.slice(3),
    };
  }

  return {
    telefono: `591${digits}`,
    telefonoVisible: digits,
  };
}

function populateFormFromClient(cliente) {
  if (!cliente || typeof cliente !== "object") {
    form.photos = [];
    validateAll();
    return;
  }

  form.nombre = cliente.nombre || cliente.nombre_club || cliente.nombreClub || "";
  form.edad = cliente.edad ?? cliente.age ?? null;
  form.nacionalidad = cliente.nacionalidad || cliente.nationality || cliente.pais || "";
  form.ciudad = cliente.ciudad || cliente.city || "";
  form.tipoLocal = cliente.tipo_local || cliente.tipoLocal || "";
  const telefonoInfo = normalizeTelefono(
    cliente.telefono || cliente.whatsapp || cliente.contacto || cliente.celular || ""
  );
  form.telefono = telefonoInfo.telefono;
  form.telefonoVisible = telefonoInfo.telefonoVisible;
  form.servicios = reconcileServiciosWithCatalog(
    normalizeTextList(cliente.servicios || cliente.servicio || cliente.tipo_atencion || cliente.tipoAtencion || [])
  );
  form.lat = cliente.lat ?? cliente.latitude ?? null;
  form.lng = cliente.lng ?? cliente.longitude ?? null;
  form.horarios = normalizeHorarios(cliente.horarios || cliente.horario || cliente.schedule || cliente.schedules || []);
  form.precios = normalizePrecios(cliente.precios || cliente.tarifas || cliente.precio_tiempo || cliente.precios_tiempo || []);
  form.disponibleAhora = !!(cliente.disponible_ahora ?? cliente.disponibleAhora);

  // 🔧 NUEVO: si ya hay coordenadas guardadas, centramos el mapa y colocamos el marcador.
  // Esto solo funciona si el mapa (Leaflet) ya terminó de inicializarse -- por eso
  // loadExistingClientData() ahora se llama DESPUÉS de crear el mapa en onMounted.
  if (form.lat != null && form.lng != null && map) {
    const coords = [Number(form.lat), Number(form.lng)];
    if (!Number.isNaN(coords[0]) && !Number.isNaN(coords[1])) {
      map.setView(coords, 14);
      if (marker) marker.setLatLng(coords);
      else marker = window.L.marker(coords, { icon: createRcMapIcon() }).addTo(map);
    }
  }

  const photoSources = [
    cliente.imagenes_urls,
    cliente.imageUrls,
    cliente.images,
    cliente.photos,
    cliente.imagenes,
    cliente.fotos,
    cliente.currentImageUrl,
    cliente.imagen_principal_url,
    cliente?.data?.imagenes_urls,
    cliente?.data?.imageUrls,
    cliente?.data?.images,
    cliente?.data?.photos,
    cliente?.data?.imagenes,
    cliente?.data?.fotos,
    cliente?.data?.imagen_principal_url,
  ].filter(Boolean);

  const existingPhotos = [...new Set(photoSources.flatMap((source) => normalizeImages(source)))];
  form.photos = existingPhotos
    .map((url) => {
      const resolvedUrl = resolveImageUrl(url);
      return resolvedUrl ? { file: null, url: resolvedUrl, id: ++photoIdCounter } : null;
    })
    .filter(Boolean);
  coverPhotoId.value = form.photos[0]?.id ?? null;
  const focalYRaw = cliente.imagen_principal_focal_y ?? cliente.imagenPrincipalFocalY;
  coverFocalY.value = Number.isFinite(Number(focalYRaw)) ? Math.min(100, Math.max(0, Number(focalYRaw))) : 50;

  validateAll();
}

async function loadExistingClientData() {
  if (!isEditMode.value) return;

  // reconcileServiciosWithCatalog (ver populateFormFromClient) necesita el
  // catálogo ya cargado para poder descartar/normalizar servicios huérfanos;
  // sin este await, loadServicios() (disparado en paralelo al montar) podía
  // no haber terminado todavía cuando llegábamos acá.
  await serviciosLoadPromise;

  const clientId = editingClientId.value;
  if (!clientId) {
    try {
      const pending = JSON.parse(sessionStorage.getItem("pendingEditClient") || "{}") || {};
      if (pending?.card) {
        populateFormFromClient(pending.card);
        return;
      }
    } catch {
      // ignora si no hay datos pendientes
    }
    return;
  }

  try {
    const endpoints = ["/contenidos/clientes", "/contenidos/cleintes", "/clientes"];
    let rows = [];

    for (const endpoint of endpoints) {
      try {
        const response = await api.get(endpoint);
        const payload = response?.data;
        const extracted = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.value)
            ? payload.value
            : Array.isArray(payload?.data)
              ? payload.data
              : [];

        if (extracted.length) {
          rows = extracted;
          break;
        }
      } catch {
        // intenta con el siguiente endpoint
      }
    }

    const cliente = rows.find((item) => String(item.id_cliente ?? item.id ?? "") === String(clientId));
    if (!cliente) {
      showToast({
        type: "error",
        title: "No se encontró la publicación",
        message: "No pudimos cargar los datos para editar.",
      });
      return;
    }

    populateFormFromClient(cliente);
  } catch (err) {
    console.error("Error al cargar publicación para editar:", err);
    showToast({
      type: "error",
      title: "No se pudo cargar la publicación",
      message: err.message || "Intenta nuevamente.",
    });
  }
}

// Mantiene el toast de "campos faltantes" sincronizado en vivo:
// si el usuario va corrigiendo campos, la lista se actualiza sola,
// y si ya no falta nada, el toast se cierra automáticamente.
watch(
  errors,
  () => {
    if (!toast.show || toast.type !== "error") return;
    const missing = getMissingFieldLabels();
    if (missing.length === 0) {
      closeToast();
    } else {
      toast.items = missing;
    }
  },
  { deep: true }
);
function validateTipoLocal() {
  errors.tipoLocal =
    form.tipoLocal === "Independiente" || form.tipoLocal === "Night Club"
      ? ""
      : "Selecciona un tipo de local";
}

function createRcMapIcon() {
  return window.L.divIcon({
    html: '<div class="rc-map-dot"></div>',
    className: "rc-map-dot-icon",
    iconSize: window.L.point(22, 22),
  });
}

// ---------- Validaciones ----------
function validateNombre() {
  errors.nombre = form.nombre.trim() === "" ? "Completa este campo" : "";
}

function validateNacionalidad() {
  if (form.tipoLocal === "Night Club") {
    errors.nacionalidad = "";
    return;
  }
  errors.nacionalidad = form.nacionalidad === "" ? "Completa este campo" : "";
}

function validateCiudad() {
  errors.ciudad = form.ciudad === "" ? "Completa este campo" : "";
}

function validateTelefono() {
  if (form.telefono === "") {
    errors.telefono = "Completa este campo";
  } else if (form.telefono.length < 10) {
    errors.telefono = "Teléfono debe tener al menos 10 dígitos";
  } else {
    errors.telefono = "";
  }
}

function validateEdad() {
  if (form.tipoLocal === "Night Club") {
    errors.edad = "";
    return;
  }
  if (form.edad === null || form.edad === "" || form.edad === undefined) {
    errors.edad = "Completa este campo";
  } else if (form.edad < 18) {
    errors.edad = "Debe ser mayor de 18 años";
  } else if (form.edad > 99) {
    errors.edad = "Verifica la edad ingresada";
  } else {
    errors.edad = "";
  }
}

function validateServicios() {
  errors.servicios = form.servicios.length === 0 ? "Selecciona al menos un servicio" : "";
}

// Ubicación ya no es obligatoria: si no se marcó un punto en el mapa, al
// guardar se usa por defecto la coordenada de la ciudad elegida (ver
// resolveUbicacionParaGuardar).
function validateUbicacion() {
  errors.ubicacion = "";
}

function openLocationModal() {
  showLocationModal.value = true;
  nextTick(() => {
    if (!map) return;
    map.invalidateSize();

    let coords = null;
    if (form.ciudad && CIUDAD_COORDS[form.ciudad]) {
      coords = CIUDAD_COORDS[form.ciudad];
    } else if (form.lat != null && form.lng != null) {
      const marcado = [Number(form.lat), Number(form.lng)];
      if (!Number.isNaN(marcado[0]) && !Number.isNaN(marcado[1])) coords = marcado;
    }

    if (coords) {
      map.setView(coords, 14);
    }
  });
}

function closeLocationModal() {
  showLocationModal.value = false;
  validateUbicacion();
}

// Horarios ya no es obligatorio (igual que ubicación y precios): si no se
// elige ninguno, el backend simplemente no calcula "disponible ahora" por
// horario para esa publicación (ver isCardAvailableNow en HomePage.vue).
function validateHorarios() {
  errors.horarios = "";
}

// Precios ya no es obligatorio: si no se eligió ninguna opción o se dejó el
// precio vacío, al guardar se completa con 0 (ver resolveUbicacionParaGuardar
// y el mapeo de payloadData en submitClient).
function validatePrecios() {
  errors.precios = "";
}

function validatePhotos() {
  errors.photos = form.photos.length === 0 ? "Sube al menos una foto" : "";
}

function validateAll() {
  validateTipoLocal();
  validateNombre();
  validateNacionalidad();
  validateCiudad();
  validateTelefono();
  validateEdad();
  validateServicios();
  validateUbicacion();
  validateHorarios();
  validatePrecios();
  validatePhotos();
}

function hasErrors() {
  return Object.values(errors).some((e) => e !== "");
}

// ---------- Interacciones ----------
function toggleServicio(s) {
  const idx = form.servicios.indexOf(s);
  if (idx === -1) {
    if (form.servicios.length >= 13) return;
    form.servicios.push(s);
  } else {
    form.servicios.splice(idx, 1);
  }
  validateServicios();
}

function toggleHora(h) {
  const idx = form.horarios.indexOf(h);
  if (idx === -1) form.horarios.push(h);
  else form.horarios.splice(idx, 1);
  validateHorarios();
}

function clampHora(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (!digits) return "";
  const n = Math.min(12, Math.max(1, Number(digits)));
  return String(n);
}

function to24Hour(n, periodo) {
  return periodo === "AM" ? (n === 12 ? 0 : n) : n === 12 ? 12 : n + 12;
}

watch([horaInicioValue, horaInicioPeriodo, horaFinValue, horaFinPeriodo], () => {
  if (horaInicioValue.value && horaInicioPeriodo.value && horaFinValue.value && horaFinPeriodo.value) {
    addHoraManual();
  }
});

function addHoraManual() {
  const nInicio = Number(horaInicioValue.value);
  const nFin = Number(horaFinValue.value);
  const inicioValido = Number.isInteger(nInicio) && nInicio >= 1 && nInicio <= 12 && horaInicioPeriodo.value;
  const finValido = Number.isInteger(nFin) && nFin >= 1 && nFin <= 12 && horaFinPeriodo.value;
  if (!inicioValido || !finValido) return;

  const hInicio = to24Hour(nInicio, horaInicioPeriodo.value);
  const hFin = to24Hour(nFin, horaFinPeriodo.value);

  form.horarios.push({ inicio: hInicio, fin: hFin });

  horaInicioValue.value = "";
  horaInicioPeriodo.value = null;
  horaFinValue.value = "";
  horaFinPeriodo.value = null;
  validateHorarios();
}

function getPrecioPreset(preset) {
  const found = form.precios.find((p) => p.tiempo === preset);
  return found && found.precio > 0 ? found.precio : null;
}

function getPrecioObj(preset) {
  return form.precios.find((p) => p.tiempo === preset);
}

function focusPrecioInput(preset) {
  nextTick(() => {
    const input = precioInputRefs[preset];
    if (input) {
      input.focus();
      input.select();
    }
  });
}

function openPrecioEditor(preset) {
  editingPrecioPreset.value = preset;
  focusPrecioInput(preset);
}

function closePrecioEditor(preset) {
  validatePrecios();
  if (editingPrecioPreset.value === preset) {
    editingPrecioPreset.value = null;
  }
}

function togglePrecioPreset(preset) {
  const incompleto = form.precios.find((p) => p.tiempo !== preset && (!p.precio || p.precio <= 0));
  if (incompleto) {
    editingPrecioPreset.value = incompleto.tiempo;
    focusPrecioInput(incompleto.tiempo);
    return;
  }

  const idx = form.precios.findIndex((p) => p.tiempo === preset);
  if (idx === -1) {
    form.precios.push({ tiempo: preset, precio: 0 });
    editingPrecioPreset.value = preset;
    focusPrecioInput(preset);
  } else {
    form.precios.splice(idx, 1);
    delete precioInputRefs[preset];
    if (editingPrecioPreset.value === preset) editingPrecioPreset.value = null;
  }
  validatePrecios();
}

function setTipoLocal(t) {
  form.tipoLocal = t;
  showTipoOptions.value = false;
  validateTipoLocal();
  validateEdad();
  validateNacionalidad();
}

function handleTipoDropdownOutsideClick(event) {
  if (showTipoOptions.value && tipoDropdownRef.value && !tipoDropdownRef.value.contains(event.target)) {
    showTipoOptions.value = false;
    validateTipoLocal();
  }
}

async function loadServicios() {
  try {
    const response = await api.get("/contenidos/servicios");
    serviciosList.value = Array.isArray(response.data)
      ? response.data
          .map((item) => {
            if (typeof item === "string") return item;
            return item.descripcion || item.description || item.nombre || item.name || "";
          })
          .filter(Boolean)
          .sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }))
      : [];
  } catch (error) {
    console.error("Error cargando servicios:", error);
    serviciosList.value = [];
  }
}

function onCiudadChange() {
  const coords = CIUDAD_COORDS[form.ciudad];
  if (coords && typeof L !== "undefined" && map) {
    map.setView(coords, 12);
  }
}

function selectCiudad(value) {
  form.ciudad = value;
  showCiudadDropdown.value = false;
  onCiudadChange();
  validateCiudad();
}

function handleCiudadDropdownOutsideClick(event) {
  if (showCiudadDropdown.value && ciudadDropdownRef.value && !ciudadDropdownRef.value.contains(event.target)) {
    showCiudadDropdown.value = false;
    validateCiudad();
  }
}

function selectNacionalidad(value) {
  form.nacionalidad = value;
  showNacionalidadDropdown.value = false;
  validateNacionalidad();
}

function handleNacionalidadDropdownOutsideClick(event) {
  if (showNacionalidadDropdown.value && nacionalidadDropdownRef.value && !nacionalidadDropdownRef.value.contains(event.target)) {
    showNacionalidadDropdown.value = false;
    validateNacionalidad();
  }
}

function addFiles(files) {
  const remaining = 13 - (form.photos?.length || 0);
  const toAdd = files.slice(0, remaining);
  toAdd.forEach((file) => {
    const url = URL.createObjectURL(file);
    form.photos.push({ file, url, id: ++photoIdCounter });
  });
  if (coverPhotoId.value == null) coverPhotoId.value = form.photos[0]?.id ?? null;
  validatePhotos();
}

function onFilesSelected(e) {
  const files = Array.from(e.target.files || []).filter((file) => file.type.startsWith("image/"));
  if (!files.length) return;
  addFiles(files);
  e.target.value = null;
}

function onDragOver(e) {
  e.preventDefault();
  dragActive.value = true;
}

function onDragLeave(e) {
  e.preventDefault();
  dragActive.value = false;
}

function onDrop(e) {
  e.preventDefault();
  dragActive.value = false;
  const files = Array.from(e.dataTransfer.files || []).filter((file) => file.type.startsWith("image/"));
  if (!files.length) return;
  addFiles(files);
}

function setCoverPhoto(i) {
  const photo = form.photos[i];
  if (!photo) return;
  coverPhotoId.value = photo.id;
  coverFocalY.value = 50;
}

// El círculo de recorte sigue directamente al mouse/dedo dentro de la caja
// de la foto de portada (ver coverFocalY, 0 = arriba, 100 = abajo). Soporta
// mouse y touch vía Pointer Events. El recorrido se limita en píxeles según
// el tamaño real del círculo para que nunca se salga de los bordes de la foto.
function startCoverFocalDrag(event) {
  event.preventDefault();
  const box = event.currentTarget.closest("[data-cover-crop-box]");
  if (!box) return;
  const rect = box.getBoundingClientRect();
  if (!rect.height) return;
  const circle = box.querySelector("[data-cover-crop-circle]");
  const circleRadius = (circle?.getBoundingClientRect().height || 0) / 2;
  const minCenter = Math.min(circleRadius, rect.height / 2);
  const maxCenter = Math.max(rect.height - circleRadius, rect.height / 2);
  isDraggingCoverFocal.value = true;

  const updateFromClientY = (clientY) => {
    const posPx = Math.min(maxCenter, Math.max(minCenter, clientY - rect.top));
    coverFocalY.value = (posPx / rect.height) * 100;
  };
  updateFromClientY(event.clientY);

  const handleMove = (moveEvent) => updateFromClientY(moveEvent.clientY);
  const stopDrag = () => {
    isDraggingCoverFocal.value = false;
    window.removeEventListener("pointermove", handleMove);
    window.removeEventListener("pointerup", stopDrag);
    window.removeEventListener("pointercancel", stopDrag);
  };
  window.addEventListener("pointermove", handleMove);
  window.addEventListener("pointerup", stopDrag);
  window.addEventListener("pointercancel", stopDrag);
}

// Arma el orden real (portada primero) solo para el envío al backend, sin
// tocar form.photos: así las miniaturas nunca se mueven en pantalla.
function buildOrderedPhotos() {
  const photos = form.photos || [];
  const coverIndex = photos.findIndex((p) => p.id === coverPhotoId.value);
  if (coverIndex <= 0) return photos;
  const ordered = [...photos];
  const [cover] = ordered.splice(coverIndex, 1);
  ordered.unshift(cover);
  return ordered;
}

function removePhoto(i) {
  const p = form.photos.splice(i, 1)[0];
  try {
    URL.revokeObjectURL(p.url);
  } catch (e) {
    console.warn("revokeObjectURL failed", e);
  }
  if (coverPhotoId.value === p.id) {
    coverPhotoId.value = form.photos[0]?.id ?? null;
    coverFocalY.value = 50;
  }
  validatePhotos();
}

function cancel() {
  // router.push (no window.location.href): una recarga completa reinicia el
  // historial de navegación en memoria de la SPA, rompiendo el "piso" de
  // App.vue que evita volver atrás hasta el login estando logueado.
  router.push("/");
}

// Detecta sesión de administrador (rol id 1) igual que HomePage.vue, para
// que el admin publique directo con estado_pago=PAGADO sin pasar por el
// modal de selección de plan / QR / comprobante.
function isAdminSession() {
  const readValue = (key) => localStorage.getItem(key) || sessionStorage.getItem(key) || "";
  const parseUser = (raw) => {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  };
  const hasAdminRole = (source) => {
    if (!source || typeof source !== "object") return false;
    const candidates = [
      source.id_rol,
      source.idRol,
      source.rol_id,
      source.rolId,
      source.role_id,
      source.roleId,
      source?.rol?.id,
      source?.role?.id,
    ];
    return candidates.some((value) => Number.parseInt(value, 10) === 1);
  };

  const rawUser = readValue("user") || readValue("authUser");
  if (hasAdminRole(parseUser(rawUser))) return true;

  const token = readValue("token");
  if (token && token.split(".").length === 3) {
    try {
      const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
      return hasAdminRole(payload);
    } catch {
      return false;
    }
  }

  return false;
}

async function submitClient() {
  if (isSubmittingClient.value) return;
  isSubmittingClient.value = true;

  // 🔧 LOG DE DIAGNÓSTICO TEMPORAL: confirma si el clic realmente dispara esta función.
  // Puedes borrar esta línea una vez que confirmes que el submit se está ejecutando.
  console.log("🔥 submitClient SE EJECUTÓ");

  try {
    validateAll();

    if (hasErrors()) {
      console.log("⚠️ Hay errores de validación:", { ...errors });
      pendingCreateSubmission.value = false;
      showToast({
        type: "error",
        title: "Faltan campos por completar",
        message: "Revisa lo siguiente antes de guardar:",
        items: getMissingFieldLabels(),
      });
      return;
    }

    // El administrador publica directo como PAGADO: no pasa por selección
    // de plan, descarga de QR ni carga de comprobante.
    const isAdminDirectPublish = !isEditMode.value && isAdminSession();

    if (!isEditMode.value && !pendingCreateSubmission.value && !isAdminDirectPublish) {
      await openPricingModal();
      return;
    }
    //comentario

    const currentUserId = localStorage.getItem('userId') || localStorage.getItem('id') || '';
    const currentUser = localStorage.getItem('user') || localStorage.getItem('authUser') || '';
    let parsedUser = null;

    try {
      parsedUser = currentUser ? JSON.parse(currentUser) : null;
    } catch {
      parsedUser = null;
    }

    const resolvedUserId = currentUserId || parsedUser?.id || parsedUser?.id_usuario || parsedUser?.idUsuario || parsedUser?.user_id || parsedUser?.userId || '';
    const activePricingOption = selectedPricingOption.value;
    const adminDirectVigenciaMs = 30 * 24 * 60 * 60 * 1000;
    const fechaVigencia = formatTimestampForBackend(
      new Date(Date.now() + (isAdminDirectPublish ? adminDirectVigenciaMs : 8 * 60 * 60 * 1000))
    );

    const orderedPhotos = buildOrderedPhotos();
    // Ubicación y precios no son obligatorios: si no se marcó un punto en el
    // mapa, se guarda null (ya no se rellena con la coordenada de la ciudad
    // elegida -ver ClientePerfil.vue, que ahora oculta la ciudad entera sin
    // un punto real); si un precio quedó sin completar, se guarda como 0 en
    // vez de bloquear el guardado.
    const latAGuardar = form.lat ?? null;
    const lngAGuardar = form.lng ?? null;
    const preciosAGuardar = form.precios.map((p) => ({ ...p, precio: Number(p.precio) || 0 }));
    const payloadData = {
      nombre: form.nombre,
      tipo_local: form.tipoLocal,
      edad: form.edad,
      nacionalidad: form.nacionalidad,
      ciudad: form.ciudad,
      tipoLocal: form.tipoLocal,
      telefono: form.telefono,
      // Se guarda en el orden en que el usuario los fue clickeando (no
      // alfabético): ClientePerfil.vue muestra los servicios en este mismo
      // orden guardado, así que el orden de selección acá ES el orden que
      // ve el visitante en el perfil.
      servicios: form.servicios,
      lat: latAGuardar,
      lng: lngAGuardar,
      horarios: buildHorariosPayload(),
      precios: preciosAGuardar,
      disponible_ahora: form.disponibleAhora,
      imagen_principal_focal_y: coverFocalY.value,
      existingPhotos: orderedPhotos.filter((photo) => !photo.file).map((photo) => photo.url),
      coverIsNewUpload: !!orderedPhotos[0]?.file,
      id_usuario_creador: resolvedUserId,
      idUsuarioCreador: resolvedUserId,
      usuario_id: resolvedUserId,
      usuarioId: resolvedUserId,
      // 🔧 NUEVO: nombre exacto de la columna en la base de datos ("usuario")
      usuario: resolvedUserId,
      precio_publicacion_id: activePricingOption?.id || "",
      precio_publicacion_titulo: activePricingOption?.title || "",
      precio_publicacion_dias: activePricingOption?.daysLabel || "",
      precio_publicacion_monto: activePricingOption?.amountValue ?? "",
      precio_publicacion_qr: activePricingOption?.qrText || "",
      num_dias: activePricingOption?.daysCount ?? (isAdminDirectPublish ? 30 : null),
      numDias: activePricingOption?.daysCount ?? (isAdminDirectPublish ? 30 : null),
      fecha_vigencia: fechaVigencia,
      fechaVigencia: fechaVigencia,
      ...(isAdminDirectPublish ? { estado_pago: "PAGADO", estadoPago: "PAGADO" } : {}),
    };

    const photoFiles = orderedPhotos.map((p) => p.file).filter(Boolean);
    // Le avisamos al backend si la portada es una foto recién subida o una ya
    // existente, para que arme imagenes_urls con ese grupo primero (ver
    // actualizarCliente en el backend) en vez de anteponer siempre las nuevas.
    const coverIsNewUpload = !!orderedPhotos[0]?.file;
    const formData = new FormData();
    formData.append("data", JSON.stringify(payloadData));
    formData.append("coverIsNewUpload", coverIsNewUpload ? "1" : "0");

    // Compatibilidad: algunos backends leen req.body directo en multipart.
    formData.append("nombre", payloadData.nombre ?? "");
    formData.append("tipo_local", payloadData.tipo_local ?? "");
    formData.append("tipoLocal", payloadData.tipoLocal ?? "");
    formData.append("edad", payloadData.edad != null ? String(payloadData.edad) : "");
    formData.append("nacionalidad", payloadData.nacionalidad ?? "");
    formData.append("ciudad", payloadData.ciudad ?? "");
    formData.append("telefono", payloadData.telefono ?? "");
    formData.append("lat", payloadData.lat != null ? String(payloadData.lat) : "");
    formData.append("lng", payloadData.lng != null ? String(payloadData.lng) : "");

    formData.append("servicios", JSON.stringify(payloadData.servicios || []));
    formData.append("horarios", JSON.stringify(payloadData.horarios || []));
    formData.append("precios", JSON.stringify(payloadData.precios || []));
    formData.append("existingPhotos", JSON.stringify(payloadData.existingPhotos || []));
    formData.append("id_usuario_creador", resolvedUserId || "");
    formData.append("idUsuarioCreador", resolvedUserId || "");
    formData.append("usuario_id", resolvedUserId || "");
    formData.append("usuarioId", resolvedUserId || "");
    // 🔧 NUEVO: campo con el nombre exacto de la columna de la BD
    formData.append("usuario", resolvedUserId || "");
    formData.append("num_dias", payloadData.num_dias ?? "");
    formData.append("numDias", payloadData.numDias ?? "");
    formData.append("fecha_vigencia", fechaVigencia);
    formData.append("fechaVigencia", fechaVigencia);
    if (isAdminDirectPublish) {
      formData.append("estado_pago", "PAGADO");
      formData.append("estadoPago", "PAGADO");
    }

    photoFiles.forEach((file) => formData.append("photos", file));
    if (comprobanteFile.value) {
      formData.append("comprobante", comprobanteFile.value);
    }

    console.log("📤 Enviando datos...", {
      isEditMode: isEditMode.value,
      editingClientId: editingClientId.value,
      payloadData,
    });

    let response;
    let postSaveWarning = "";
    if (isEditMode.value && editingClientId.value) {
      response = await api.put(`/clientes/${editingClientId.value}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    } else {
      response = await postCliente(formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const createdClientId = extractCreatedClientId(response);
      if (activePricingOption) {
        if (!createdClientId) {
          postSaveWarning = "La publicación se guardó, pero no se pudo registrar su vigencia inicial.";
          console.error("No se recibió id_cliente para registrar vigencia inicial", response?.data);
        } else {
          try {
            await registerInitialVigenciaWindow({
              clientId: createdClientId,
            });
          } catch (syncError) {
            postSaveWarning = "La publicación se guardó, pero falló la activación inicial de 1 día.";
            console.error("Error registrando vigencia inicial:", syncError);
          }
        }
      }
    }

    console.log("Respuesta del servidor:", response);
    pendingCreateSubmission.value = false;
    showToast({
      type: "success",
      title: isEditMode.value ? "Publicación actualizada" : "Registro guardado",
      message: isEditMode.value
        ? "Tus cambios se guardaron correctamente."
        : postSaveWarning || (isAdminDirectPublish
          ? "Publicación registrada y activada."
          : "Tu publicación se guardó correctamente, en unos momentos estará publicada."),
      duration: 5000,
    });
    setTimeout(() => {
      router.push("/");
    }, 5000);
  } catch (error) {
    console.error("❌ Error al guardar:", error);
    console.error("Detalle de la respuesta del servidor:", error?.response?.data);
    pendingCreateSubmission.value = false;
    const errorMsg = error.response?.data?.message || error.message || "Error desconocido al guardar";
    showToast({
      type: "error",
      title: "No se pudo guardar",
      message: errorMsg,
    });
  } finally {
    isSubmittingClient.value = false;
  }
}

onMounted(() => {
  const Lcss = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
  const Ljs = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
  if (!document.querySelector(`link[href="${Lcss}"]`)) {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = Lcss;
    document.head.appendChild(l);
  }
  const loadScript = (src) =>
    new Promise((res, rej) => {
      if (document.querySelector(`script[src="${src}"]`)) return res();
      const s = document.createElement("script");
      s.src = src;
      s.onload = res;
      s.onerror = rej;
      document.head.appendChild(s);
    });

  serviciosLoadPromise = loadServicios();
  // 🔧 loadExistingClientData() YA NO se llama aquí -- se movió a después de crear el mapa,
  // porque antes se ejecutaba en paralelo con la carga de Leaflet y el marcador nunca
  // se podía colocar (el mapa aún no existía).

  loadScript(Ljs)
    .then(() => {
      if (typeof window.L === "undefined") {
        showToast({
          type: "error",
          title: "Mapa no disponible",
          message: "No se pudo cargar el mapa. Intenta recargar la página.",
        });
        return;
      }

      map = window.L.map("rc-map").setView([0, 0], 2);
      window.L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
        maxZoom: 20,
        subdomains: "abcd",
        attribution: "© OpenStreetMap contributors © CARTO",
      }).addTo(map);
      marker = null;
      map.on("click", (e) => {
        const { lat, lng } = e.latlng;
        form.lat = lat.toFixed(6);
        form.lng = lng.toFixed(6);
        if (marker) marker.setLatLng(e.latlng);
        else marker = window.L.marker(e.latlng, { icon: createRcMapIcon() }).addTo(map);
        map.setView(e.latlng, 14);
        validateUbicacion();
      });

      // 🔧 NUEVO: ahora que el mapa ya existe, recién cargamos los datos del cliente
      // (en modo edición). Así populateFormFromClient() puede colocar el marcador.
      loadExistingClientData();
    })
    .catch((err) => {
      console.error("Leaflet load error", err);
      showToast({
        type: "error",
        title: "Mapa no disponible",
        message: "No se pudo cargar la vista del mapa. Intenta recargar la página.",
      });
    });

  document.addEventListener("click", handleCiudadDropdownOutsideClick);
  document.addEventListener("click", handleNacionalidadDropdownOutsideClick);
  document.addEventListener("click", handleTipoDropdownOutsideClick);
});

onUnmounted(() => {
  document.removeEventListener("click", handleCiudadDropdownOutsideClick);
  document.removeEventListener("click", handleNacionalidadDropdownOutsideClick);
  document.removeEventListener("click", handleTipoDropdownOutsideClick);
});
</script>

<style scoped>
#rc-map {
  min-height: 12rem;
}

/* Oscurece el texto de botones y selects (solo en este formulario) */
.text-plomo {
  color: #475569;
}

/* ---------- Transición del listado desplegable de ciudad ---------- */
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* ---------- Efecto de presión en todos los botones ---------- */
button {
  transition: transform 0.12s ease, filter 0.12s ease, box-shadow 0.12s ease;
}
button:active:not(:disabled) {
  transform: scale(0.94);
  filter: brightness(0.95);
}

/* ---------- Tooltip de error elegante ---------- */
.error-tooltip {
  position: absolute;
  z-index: 30;
  top: calc(100% + 0.5rem);
  left: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 180px;
  max-width: 280px;
  padding: 0.6rem 0.9rem;
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border: 1px solid rgba(245, 158, 11, 0.35);
  border-radius: 0.9rem;
  box-shadow: 0 12px 30px -8px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.02);
  font-size: 0.8rem;
  line-height: 1.15rem;
  color: #fca5a5;
  white-space: normal;
}

.error-tooltip-arrow {
  position: absolute;
  top: -6px;
  left: 18px;
  width: 12px;
  height: 12px;
  background: #1e293b;
  border-left: 1px solid rgba(245, 158, 11, 0.35);
  border-top: 1px solid rgba(245, 158, 11, 0.35);
  transform: rotate(45deg);
}

.error-tooltip-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 0.5rem;
  background: #f59e0b;
  color: #1e293b;
  font-weight: 800;
  font-size: 0.85rem;
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.4);
}

.error-tooltip-text {
  color: #e2e8f0;
}

.fade-tooltip-enter-active,
.fade-tooltip-leave-active {
  transition: all 0.18s ease;
}
.fade-tooltip-enter-from,
.fade-tooltip-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* ---------- Toast elegante (reemplaza alert()) ---------- */
.app-toast {
  position: fixed;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  max-width: 22rem;
  padding: 1rem 1.1rem;
  border-radius: 1.1rem;
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 45px -12px rgba(0, 0, 0, 0.65), 0 0 0 1px rgba(255, 255, 255, 0.02);
  color: #e2e8f0;
}

@media (max-width: 480px) {
  .app-toast {
    left: 1rem;
    right: 1rem;
    top: 1rem;
    max-width: none;
  }
}

.app-toast-error {
  border-left: 4px solid #f43f5e;
}
.app-toast-success {
  border-left: 4px solid #22c55e;
}

.app-toast-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.6rem;
  font-weight: 800;
  font-size: 0.95rem;
}
.app-toast-error .app-toast-icon {
  background: #f43f5e;
  color: #fff;
}
.app-toast-success .app-toast-icon {
  background: #22c55e;
  color: #062e14;
}

.app-toast-body {
  flex: 1;
  min-width: 0;
}

.app-toast-title {
  margin: 0;
  font-weight: 700;
  font-size: 0.92rem;
  color: #f8fafc;
}

.app-toast-message {
  margin: 0.2rem 0 0;
  font-size: 0.82rem;
  color: #94a3b8;
}

.app-toast-list {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
  font-size: 0.82rem;
  color: #fca5a5;
  list-style: disc;
}
.app-toast-list li {
  margin-top: 0.15rem;
}

.app-toast-close {
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: #64748b;
  cursor: pointer;
  font-size: 0.85rem;
  line-height: 1;
  padding: 0.2rem;
  border-radius: 0.4rem;
  transition: background 0.15s ease, color 0.15s ease;
}
.app-toast-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
}

.toast-slide-enter-active,
.toast-slide-leave-active {
  transition: all 0.25s ease;
}
.toast-slide-enter-from,
.toast-slide-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>

<!-- Estilos globales para el marcador del mapa (Leaflet crea el DOM fuera del scope) -->
<style>
.rc-map-dot-icon {
  background: transparent;
  border: none;
}

.rc-map-dot {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #ffffff;
  background: #dc2626;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
}

.rc-map-dot::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: #dc2626;
  animation: rcMapDotPing 1.8s cubic-bezier(0, 0, 0.2, 1) infinite;
}

@keyframes rcMapDotPing {
  0% {
    transform: scale(1);
    opacity: 0.65;
  }
  100% {
    transform: scale(2.6);
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .rc-map-dot::before {
    animation: none;
  }
}
</style>